module.exports = __webpack_public_path__ + "img/Dkterma-1138-655-312.4c80742e.png";